{
  "name": "esri-leaflet-cluster",
  "description": "Esri Leaflet plugin for visualizing Feature Layers as clusters with L.markercluster.",
  "version": "3.0.1",
  "author": "Patrick Arlt <parlt@esri.com> (http://patrickarlt.com)",
  "contributors": [
    "Patrick Arlt <parlt@esri.com> (http://patrickarlt.com)",
    "John Gravois (http://johngravois.com)"
  ],
  "peerDependencies": {
    "esri-leaflet": "*",
    "leaflet": "*",
    "leaflet.markercluster": "^1.0.0"
  },
  "devDependencies": {
    "@rollup/plugin-json": "^6.0.0",
    "@rollup/plugin-node-resolve": "^15.0.1",
    "@rollup/plugin-terser": "^0.4.0",
    "chai": "4.3.7",
    "chokidar-cli": "^3.0.0",
    "gh-release": "^7.0.2",
    "http-server": "^14.1.1",
    "karma": "^6.4.1",
    "karma-chrome-launcher": "^3.1.1",
    "karma-coverage": "^2.2.0",
    "karma-edgium-launcher": "github:matracey/karma-edgium-launcher",
    "karma-firefox-launcher": "^2.1.2",
    "karma-mocha": "^2.0.1",
    "karma-mocha-reporter": "^2.2.5",
    "karma-safari-launcher": "~1.0.0",
    "karma-sinon-chai": "^2.0.2",
    "karma-sourcemap-loader": "^0.3.8",
    "mkdirp": "^1.0.4",
    "mocha": "^10.2.0",
    "node-sass": "^7.0.1",
    "npm-run-all": "^4.1.5",
    "rollup": "^2.79.1",
    "semistandard": "^11.0.0",
    "sinon": "^15.0.1",
    "sinon-chai": "3.7.0",
    "snazzy": "^9.0.0"
  },
  "homepage": "https://github.com/Esri/esri-leaflet-cluster",
  "jsnext:main": "src/ClusterFeatureLayer.js",
  "jspm": {
    "registry": "npm",
    "format": "es6",
    "main": "src/ClusterFeatureLayer.js"
  },
  "keywords": [
    "arcgis",
    "esri",
    "esri leaflet",
    "gis",
    "leaflet plugin",
    "mapping"
  ],
  "license": "Apache-2.0",
  "main": "dist/esri-leaflet-cluster-debug.js",
  "module": "src/ClusterFeatureLayer.js",
  "readmeFilename": "README.md",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/Esri/esri-leaflet-cluster.git"
  },
  "scripts": {
    "prebuild": "mkdirp dist",
    "build": "rollup -c profiles/debug.js & rollup -c profiles/production.js",
    "lint": "semistandard | snazzy",
    "pretest": "npm run build",
    "release": "./scripts/release.sh",
    "start-watch": "chokidar src -c \"npm run build\"",
    "start": "run-p start-watch serve",
    "serve": "http-server -p 5678 -c-1 -o",
    "test": "npm run lint && karma start"
  },
  "semistandard": {
    "globals": [
      "expect",
      "L",
      "sinon"
    ]
  }
}
